import {useLazyGetProductDataQuery as useQuery} from 'components/customer/Product/store/productApi';
import {setProductDataLoading} from 'components/customer/Product/store/productSlice';
import {useCallback, useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useAppDispatch} from 'store/customer';

export const useLazyGetProductDataQuery = () => {
    const dispatch = useAppDispatch();
    const [getProductData, data] = useQuery();
    const [searchParams] = useSearchParams();

    const cabinetId = searchParams.get('cabinetId');

    const fetchData = useCallback(
        (
            params: {
                cabinetType?: number;
                roomId?: number;
                cabinetId?: number;
                materialId?: number;
                edgeId?: number;
                doorId?: number;
                doorFilter?: string;
            },
            preferCache?: boolean
        ) => {
            return getProductData(params, preferCache);
        },
        [getProductData]
    );

    useEffect(() => {
        dispatch(setProductDataLoading(data.isLoading || data.isFetching));

        return () => {
            // NOTE: If network is slow enough, this effect does not
            // gets called so state is not toggled off if it has been
            // toggled on and component unmounts.

            // This assumes that if component is unmounted, then loading
            // data is not relevant anymore and sets the state to false.
            dispatch(setProductDataLoading(false));
        };
        // NOTE: using cabinetId here as dependency even if we are not using
        // it inside effect because if form is open and other product is
        // selected i.e. with reloading the page. The callback is called
        // but, since cached data is used, this effect does not get fired
        // as both data.isLoading and data.isFetching is unchanged. adding
        // cabinetId in dependency array ensures that this effect is called
        // and loading state is properly set.
    }, [data.isLoading, data.isFetching, cabinetId]);

    return [fetchData, data] as const;
};
